import React, { useEffect, useState } from 'react';
import { FormattedMessage } from '../../util/reactIntl';
import Modal from '../Modal/Modal';
import IconClose from '../IconClose/IconClose';
import promoImage from '../../assets/roboup-promo-printemps.png';
import {
  isApril2026CampaignActive,
  isUserSignupApril2026,
  isRoboupLawnMowerListing,
} from '../../util/promoPrintempsRoboupClient';
import { hasCookieConsent } from '../../util/cookieConsent';
import { hideTidioChat, showTidioChat } from '../../util/tidioChat';

import CountdownTimer from './CountdownTimer';
import css from './PrintempsRoboupPromo.module.css';

const SESSION_KEY = 'roboupCartPromoShown_20260412';

const PrintempsRoboupCartModal = ({
  cart,
  listingsById,
  cartPromoCode,
  currentUser,
  onApplyPromo,
}) => {
  const [open, setOpen] = useState(false);

  useEffect(() => {
    if (typeof window === 'undefined') return;
    if (!isApril2026CampaignActive()) return;
    if (currentUser?.id && !isUserSignupApril2026(currentUser.attributes?.createdAt)) return;
    if (cartPromoCode) return;
    if (window.sessionStorage.getItem(SESSION_KEY) === '1') return;

    const hasEligibleItem = Object.values(cart || {}).some(providerData => {
      const items = Array.isArray(providerData) ? providerData : providerData?.items || [];
      return items.some(item => {
        const listingId = item?.listingId?.uuid || item?.listingId;
        const listing = listingsById[listingId];
        return listing && isRoboupLawnMowerListing(listing.attributes?.publicData);
      });
    });

    if (!hasEligibleItem) return;

    const scheduleModal = () => {
      return setTimeout(() => {
        setOpen(true);
        window.sessionStorage.setItem(SESSION_KEY, '1');
      }, 1200);
    };

    if (hasCookieConsent()) {
      const timer = scheduleModal();
      return () => clearTimeout(timer);
    }

    let timer;
    const onConsentGiven = () => {
      timer = scheduleModal();
    };
    window.addEventListener('cookieConsentUpdated', onConsentGiven);
    return () => {
      window.removeEventListener('cookieConsentUpdated', onConsentGiven);
      if (timer) clearTimeout(timer);
    };
  }, [cart, listingsById, cartPromoCode, currentUser?.id?.uuid]);

  useEffect(() => {
    if (open) {
      hideTidioChat();
    } else {
      showTidioChat();
    }
  }, [open]);

  const close = () => setOpen(false);

  const handleApply = () => {
    if (onApplyPromo) onApplyPromo('PRINTEMPSROBOUP');
    close();
  };

  return (
    <Modal
      id="PrintempsRoboupCartModal"
      isOpen={open}
      onClose={close}
      onManageDisableScrolling={() => {}}
      scrollLayerClassName={css.modalScrollLayer}
      containerClassName={css.modalContainer}
      hideCloseButton
      usePortal
    >
      <nav className={css.modalCloseNav}>
        <button type="button" className={css.modalCloseBtn} onClick={close} aria-label="Fermer">
          <IconClose rootClassName={css.modalCloseIcon} />
        </button>
      </nav>
      <div className={css.root}>
        <img
          src={promoImage}
          alt="Robot tondeuse RoboUP"
          className={css.heroImage}
        />
        <div className={css.rootBody}>
          <span className={css.badge}>
            <FormattedMessage id="PrintempsRoboupPromo.easterBadge" />
          </span>
          <CountdownTimer />
          <h2 className={css.title}>
            <FormattedMessage id="PrintempsRoboupPromo.cartTitle" />
          </h2>
          <p className={css.text}>
            <FormattedMessage id="PrintempsRoboupPromo.cartBody" />
          </p>
          <div className={css.codeBox} aria-label="PRINTEMPSROBOUP">
            PRINTEMPSROBOUP
          </div>
          <p className={css.hint}>
            <FormattedMessage id="PrintempsRoboupPromo.cartHint" />
          </p>
          <button type="button" className={css.cta} onClick={handleApply}>
            <FormattedMessage id="PrintempsRoboupPromo.ctaApply" />
          </button>
        </div>
      </div>
    </Modal>
  );
};

export default PrintempsRoboupCartModal;
